module.exports = __webpack_public_path__ + "img/kamalized.2000c545.jpg";